import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import logo from '../../assets/images/web.png';
import { setData } from '../../core/redux/app/Actions';
import './RegisterScreen.scss';

const RegisterScreen = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const company = useSelector((state) => state.app.company || {});

  return (
    <div className="dashboard-placement">
      <div className="dashboard-home">
        <div>
          <img className="dashboard-logo" src={logo} />
        </div>
        <div className="dashboard-button-placement register-button-grid">
          <div
            className="location-button"
            onClick={() => {
              history.push(`/modules`);
              dispatch(setData({ navigate: `/modules` }));
            }}
          >
            <text>Módulo Funilaria e Pintura</text>
          </div>
          <div
            // style={company?.id != 160 ? { display: 'none' } : {}}
            className="location-button"
            onClick={() => {
              history.push(`/modules-aesthetic`);
              dispatch(setData({ navigate: `/modules-aesthetic` }));
            }}
          >
            <text>Módulo Serviços</text>
          </div>
          <div
            className="location-button"
            onClick={() => {
              history.push(`/company`);
              dispatch(setData({ navigate: `/company` }));
            }}
          >
            <text>Empresas</text>
          </div>

          <div
            className="location-button"
            onClick={() => {
              history.push(`/parts`);
              dispatch(setData({ navigate: `/parts` }));
            }}
          >
            <text>Peças/Produtos</text>
          </div>

          <div
            className="location-button"
            onClick={() => {
              history.push(`/clients`);
              dispatch(setData({ navigate: `/clients` }));
            }}
          >
            <text>Clientes</text>
          </div>

          <div
            className="location-button"
            onClick={() => {
              history.push(`/vehicles`);
              dispatch(setData({ navigate: `/vehicles` }));
            }}
          >
            <text>Veículos</text>
          </div>

          <div
            className="location-button"
            onClick={() => {
              history.push(`/suppliers`);
              dispatch(setData({ navigate: `/suppliers` }));
            }}
          >
            <text>Fornecedores</text>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterScreen;
